import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "image", "placeholder", "removeFlag", "removeButton"]

  disconnect() {
    if (this.currentUrl) URL.revokeObjectURL(this.currentUrl)
  }

  preview() {
    const file = this.inputTarget.files?.[0]
    if (!file) return

    if (this.currentUrl) URL.revokeObjectURL(this.currentUrl)
    this.currentUrl = URL.createObjectURL(file)

    this.imageTarget.src = this.currentUrl
    this.imageTarget.classList.remove("hidden")
    this.placeholderTarget?.classList.add("hidden")
    if (this.hasRemoveFlagTarget) this.removeFlagTarget.value = "0"
    this.removeButtonTarget?.classList.remove("hidden")
  }

  remove() {
    this.inputTarget.value = ""
    if (this.currentUrl) {
      URL.revokeObjectURL(this.currentUrl)
      this.currentUrl = null
    }
    this.imageTarget.src = ""
    this.imageTarget.classList.add("hidden")
    this.placeholderTarget?.classList.remove("hidden")
    if (this.hasRemoveFlagTarget) this.removeFlagTarget.value = "1"
    this.removeButtonTarget?.classList.add("hidden")
  }
}
